import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/projects/create`; also keeps "new" from being read as a project id.
export const Route = createFileRoute('/_authenticated/projects/new')({
    // Only redirects: `create` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/projects/create', search: true, replace: true });
    },
});
